"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var Text_1 = require("./Text");
var colors_1 = require("../colors");
var COLOR_SET = {
    dark: {
        backgroundColor: 'VELVET_30',
        borderColor: 'LIGHT_PURPLE_50',
        color: 'DARK_PURPLE_100',
    },
    light: {
        backgroundColor: 'YELLOW_BG',
        borderColor: 'YELLOW_100',
        color: 'BLACK_60',
    },
};
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    button: function (props) { return ({
        backgroundColor: (0, colors_1.getColor)(props.isSelected ? COLOR_SET[props.variant].backgroundColor : 'WHITE_100'),
        border: "1px solid ".concat((0, colors_1.getColor)(COLOR_SET[props.variant].borderColor)),
        borderRadius: 38,
        cursor: 'pointer',
        padding: '8px 16px',
        '&:disabled': {
            cursor: 'not-allowed',
        },
    }); },
}); });
var Tag = function (_a) {
    var className = _a.className, disabled = _a.disabled, isSelected = _a.isSelected, label = _a.label, onClick = _a.onClick, value = _a.value, variant = _a.variant;
    var classes = useStyles({ isSelected: isSelected, variant: variant });
    return (react_1.default.createElement("button", { className: (0, clsx_1.default)(classes.button, className), disabled: disabled, onClick: function () { return onClick(value); }, type: 'button' },
        react_1.default.createElement(Text_1.Text, { variant: 'body', color: COLOR_SET[variant].color }, label || value)));
};
exports.Tag = Tag;
